module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-7-0fe0d27f19898a5c395541c9aefbd0d3.webp";